import * as React from "react";
import Auth from "../../features/auth/components/Auth";
import Chat from "../../features/chat/components/Chat";
import { Flex, Text, IconButton, Tooltip } from "@radix-ui/themes";
import { SignOutIcon } from "@phosphor-icons/react";
import { useAuth } from "../../features/auth/hooks/useAuth";
import { STRINGS } from "../../constants/strings";

export interface AppProps {
  title?: string;
}

const App: React.FC<AppProps> = () => {
  const { isAuthenticated, login, logout, loading, error, requireOrgSelection, organizations, selectOrganization } = useAuth();

  if (!isAuthenticated) {
    return (
      <Auth 
        onLogin={login} 
        loading={loading} 
        error={error} 
        requireOrgSelection={requireOrgSelection}
        organizations={organizations}
        onSelectOrganization={selectOrganization}
      />
    );
  }

  return (
    <Flex direction="column" style={{ height: "100vh", overflow: "hidden" }}>
      <Flex 
        justify="between" 
        align="center" 
        py="2"
        px="3"
        style={{ 
          borderBottom: "1px solid var(--gray-5)",
          backgroundColor: "var(--color-panel-solid)",
          flexShrink: 0
        }}
      >
        <Text size="2" weight="medium" color="gray">{STRINGS.APP.CURRENT_CONTEXT}</Text>
        <Tooltip content={STRINGS.APP.SIGN_OUT}>
          <IconButton variant="ghost" color="gray" size="2" onClick={logout}>
            <SignOutIcon size={16} />
          </IconButton>
        </Tooltip>
      </Flex>
      <Chat />
    </Flex>
  );
};

export default App;
